/**
 * Unique billing periods from plan currency offers, sorted ascending.
 *
 * @param {Array<{ currency_offers?: Array<{ periods?: number }> }>|null|undefined} plans
 * @returns {number[]}
 */
const getAllowedPeriods = plans => {
  const periods = [];

  if (Array.isArray(plans)) {
    for (const plan of plans) {
      if (!Array.isArray(plan?.currency_offers)) {
        continue;
      }

      for (const offer of plan.currency_offers) {
        if (typeof offer?.periods === "number" && !Number.isNaN(offer.periods)) {
          periods.push(offer.periods);
        }
      }
    }
  }

  return [...new Set(periods)].sort((a, b) => a - b);
};

export default getAllowedPeriods;
